import React from "react";
import "./Subtotal.css";
import { NumericFormat } from 'react-number-format';
import { useStateValue } from "./StateProvider";
import { getBasketTotal } from "./reducer";
import { useNavigate } from "react-router-dom"

function Subtotal() {
    const navigate = useNavigate()
    const [{ basket }] = useStateValue();
  return (
    <div className="subtotal">
        {/* Price */}

        <NumericFormat
          renderText={(value) => (
            <>
              <p>
                Subtotal ({basket.length} item): <strong>${getBasketTotal(basket).toFixed(2)}</strong>
              </p>
              <small className="subtotal__gift">
                <input type="checkbox" /> This order contain
              </small>
            </>
          )}
          decimalScale={2}
          value={getBasketTotal(basket)}
          displayType={"text"}
          thousandSeparator={true}
          prefix={"$"}
          />
        <button onClick={e => navigate('/payment')}>Proceed to checkout</button>
    </div>
  )
}

export default Subtotal
